
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-7-feb.webp'


const Event33 = () => {
    useEffect(() => {
        document.title = "An IEC workshop on HVAC Fans Selection & Application";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>7 February 2026</h1>
        <h3 className='text-center'>An IEC workshop on HVAC Fans Selection & Application  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='An IEC workshop on HVAC Fans Selection & Application'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/zNjNdb63WAY=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event33




